import { render, staticRenderFns } from "./NewsBoardBox.vue?vue&type=template&id=32e6360a&scoped=true&"
import script from "./NewsBoardBox.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardBox.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoardBox.vue?vue&type=style&index=0&id=32e6360a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e6360a",
  null
  
)

export default component.exports